import { render, staticRenderFns } from "./ClippyHelper.vue?vue&type=template&id=132557a6&"
import script from "./ClippyHelper.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClippyHelper.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClippyHelper.vue?vue&type=style&index=0&id=132557a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports